import { useEffect } from "react";
import { flexRender } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { Card, Table as BaseTable } from "reactstrap";
import classNames from "classnames";
import Pagination from "./Pagination";
import Loading from "../Loaders/Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSort, faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";
import "./style.scss";

function Table({ table, pagination = true, hasChangedDateFilter, setHasChangedDateFilter }) {
    const { t } = useTranslation();
    const { loading, totalItems, getRowProps } = table.options.meta;

    useEffect(() => {
        if (hasChangedDateFilter) {
            table.setPageIndex(0);
            setHasChangedDateFilter?.(false);
        }
    }, [table.setPageIndex, setHasChangedDateFilter, hasChangedDateFilter])

    return (
        <Card className="mb-0 h-100">
            <BaseTable
                className="align-items-center table-flush new-table"
                hover
                responsive
            >
                <thead className="thead-light">
                    {table.getHeaderGroups().map(headerGroup => (
                        <tr key={headerGroup.id} title={t("sort-by-column")}>
                            {headerGroup.headers.map(header => {
                                const canSort = header.column.getCanSort();
                                const className = classNames(
                                    header.column.getCanSort() && 'cursor-pointer select-none',
                                );
                                const sortDirection = header.column.getIsSorted();
                                const sortIcon = sortDirection
                                    ? sortDirection === "desc" ? faSortDown : faSortUp
                                    : faSort;
                                return (
                                    <th
                                        key={header.id}
                                        colSpan={header.colSpan}
                                        className={className}
                                        onClick={header.column.getToggleSortingHandler()}
                                        style={{ color: "#000000b5", borderTop: 0 }}
                                    >
                                        {header.isPlaceholder ? null : (
                                            <div>
                                                {flexRender(
                                                    header.column.columnDef.header,
                                                    header.getContext()
                                                )}

                                                {canSort && (
                                                    <FontAwesomeIcon className="ml-2" icon={sortIcon} />
                                                )}
                                            </div>
                                        )}
                                    </th>
                                );
                            })}
                        </tr>
                    ))}
                </thead>

                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan="999">
                                <div className="d-flex justify-content-center">
                                    <Loading />
                                </div>
                            </td>
                        </tr>
                    ) : totalItems === 0 ? (
                        <tr>
                            <td colSpan="999">
                                <div className="d-flex justify-content-center">
                                    {t("no-data")}
                                </div>
                            </td>
                        </tr>
                    ) : (
                        table.getRowModel().rows.map((row) => {
                            /*
                                TODO: ne te tilla rastesh ta shperblefsha eljan
                                    (row.original?.summaryColumns?.length > 0 ||
                                        row.original?.footerColumns?.length > 0) ? (
                                        <tr
                                            className={classNames(
                                                "w-100 text-white font-weight-bolder",
                                                row.original.class
                                                    ? row.original.class
                                                    : row.original
                                                        ?.summaryColumns
                                                        ?.length > 0
                                                        ? "bg-info"
                                                        : "bg-gray",
                                            )}
                                        >
                                            {(
                                                row.original.summaryColumns ||
                                                row.original.footerColumns
                                            ).map((r) => {
                                                return (
                                                    <td
                                                        className="text-sm"
                                                        colSpan={r.colSpan}
                                                        key={r.accessor}
                                                    >
                                                        {r.value}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                            */
                            if (row?.original?.summary === 1) {
                                return <tr key={row?.id} {...getRowProps?.(row)} className="bg-info text-white">
                                    {row?.getVisibleCells()?.map((cell) => (
                                        <td key={cell.id}>
                                            {flexRender(
                                                cell.column.columnDef.cell,
                                                cell.getContext(),
                                            )}
                                        </td>
                                    ))}
                                </tr>
                            } else if (row?.original?.summary === 2) {
                                return <tr key={row?.id} {...getRowProps?.(row)} className="bg-primary text-white">
                                    {row?.getVisibleCells()?.map((cell) => (
                                        <td key={cell.id}>
                                            {flexRender(
                                                cell.column.columnDef.cell,
                                                cell.getContext(),
                                            )}
                                        </td>
                                    ))}
                                </tr>
                            } else {
                                return (
                                    <tr key={row.id} {...getRowProps?.(row)}>
                                        {row.getVisibleCells().map((cell) => (
                                            <td key={cell.id}>
                                                {flexRender(
                                                    cell.column.columnDef.cell,
                                                    cell.getContext(),
                                                )}
                                            </td>
                                        ))}
                                    </tr>
                                );
                            }
                        })
                    )}
                </tbody>
            </BaseTable>

            {pagination && <Pagination
                page={table.getState().pagination.pageIndex}
                pageCount={table.getPageCount()}
                perPage={table.getState().pagination.pageSize}
                gotoPage={table.setPageIndex}
                setPerPage={table.setPageSize}
                totalItems={totalItems}
            />}
        </Card>
    );
}

export default Table;
